<template>
  <div>
    <div ref="optionalArticleComponentRef" class="article optional-article-set" :class="$parent.responsiveClass">
      <div class="article-container clearfix">
        <div class="image-container">
          <div class="image-wrapper">
            <div id="optional-article-image"
                 :ref="'optional_article_image_' + optionalArticle.articles[0].articleCode"
                 class="image content-temp"
            />
          </div>
        </div>
        <div class="description-container">
          <div class="description-wrapper clearfix">
            <div class="details-container">
              <div id="optional-article-name"
                   :ref="'optional_article_name_' + optionalArticle.articles[0].articleCode"
                   class="details-title content-temp"
              >
                {{ optionalArticle.articles[0].articleName }}
              </div>
              <div id="optional-article-description"
                   :ref="'optional_article_description_' + optionalArticle.articles[0].articleCode"
                   class="details-wrapper content-temp"
              />
            </div>
            <div class="counter-container">
              <div class="counter-wrapper">
                <div v-if="optionalArticle.articlesBookedPer != 'booking'">
                  <div
                    v-if="optionalArticle != null && updatedCommonTravellers != null && getTotalTravelCount(updatedCommonTravellers) > 1"
                  >
                    <div v-if="optionalArticle.otherPrices != null && optionalArticle.otherPrices.length > 0"
                         class="counter"
                    >
                      <div class="choose-quantity" @click="openQuantityPopup">
                        <div v-if="selectedCategoriesSet.length > 0" class="qty-label">
                          {{ selectedCategories }}
                        </div>
                        <div v-else class="qty-label">
                          {{ $t('chooseQuantities') }}
                        </div>
                      </div>
                    </div>
                    <div v-if="optionalArticle.tours != null && optionalArticle.tours.length > 0"
                         class="optional-art-tours"
                    >
                      <select v-model="selectedTourTime" @change="tourChange">
                        <option selected="selected">
                          Select Tour
                        </option>
                        <option v-for="tour in optionalArticle.tours" :key="tour.tourId"
                                :value="tour"
                        >
                          Departure : {{ convertToLocal(tour.datetime, "HH:mm") }} Return : {{
                            getArrivalDate(tour.datetime, "HH:mm", tour.duration, "minutes") }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div
                    v-if="optionalArticle != null && updatedCommonTravellers != null && getTotalTravelCount(updatedCommonTravellers) < 2"
                  >
                    <div class="check">
                      <label
                        v-if="optionalArticle.otherPrices != null && optionalArticle.otherPrices.length > 0"
                        class="check-container"
                      >
                        +{{ optionalArticle.otherPrices[0].unitPrice }} SEK
                        <input v-model="selectedOption" type="checkbox"
                               @change="quantityChangeCheckBox(selectedOption, commonTravellersSet)"
                        >
                        <span class="checkmark" />
                      </label>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="counter">
                    <div class="choose-quantity" @click="openQuantityPopup">
                      <div class="qty-label">
                        {{ selectedCategories }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div v-if="isQtyPopupOpen" class="qty-popup-container">
            <div class="overlay">
              <div class="popup">
                <div class="popup-container">
                  <div class="close" @click="closeQuantityPopup" />
                  <div v-if="optionalArticle.articlesBookedPer != 'booking'"
                       class="drop-container clearfix"
                  >
                    <div v-if="isAdvancedOption">
                      <div v-for="commonTraveller in updatedCommonTravellers"
                           :key="commonTraveller.key" class="optionItem"
                      >
                        <div class="label">
                          {{ commonTraveller.name }}
                        </div>
                        <select
                          @change="changeItem($event.target.value, commonTraveller.key, commonTraveller.name)"
                        >
                          <option :value="'default'" selected="selected">
                            Qauntity
                          </option>

                          <option
                            v-for="index in (optionalArticle.maximumQuantity - (optionalArticle.minimumQuantity - 1))"
                            :key="index + optionalArticle.minimumQuantity - 1"
                            :value="index + optionalArticle.minimumQuantity - 1"
                          >
                            {{ index + optionalArticle.minimumQuantity - 1 }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-else>
                      <div v-for="commonTraveller in updatedCommonTravellers"
                           :key="commonTraveller.key" class="optionItem"
                      >
                        <div class="label">
                          {{ commonTraveller.name }}
                        </div>
                        <select @change="changeItem($event.target.value)">
                          <option :value="'default|' + commonTraveller.key" selected="selected">
                            {{ commonTraveller.name }}
                          </option>
                          <option v-for="index in commonTraveller.value" :key="index"
                                  :title="commonTraveller.name"
                                  :value="index + '|' + commonTraveller.key + '|' + commonTraveller.name + '|' + commonTraveller.unitPrice"
                                  :selected="isInSelectedArray(index + '|' + commonTraveller.key + '|' + commonTraveller.name + '|' + commonTraveller.unitPrice)"
                          >
                            x{{ index }} (+{{ commonTraveller.unitPrice }} SEK)
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-else class="drop-container clearfix">
                    <div class="optionItem">
                      <div class="label">
                        Quantity
                      </div>
                      <select @change="changeItem($event.target.value)">
                        <option :value="'default'" selected="selected">
                          Qauntity
                        </option>

                        <option
                          v-for="index in (optionalArticle.maximumQuantity - (optionalArticle.minimumQuantity - 1))"
                          :key="index + optionalArticle.minimumQuantity - 1"
                          :value="index + optionalArticle.minimumQuantity - 1"
                        >
                          {{ index + optionalArticle.minimumQuantity - 1 }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment-duration-format";
export default {
    name: "OptionalArticleComponent",
    props: {
        optionalArticle: {
            type: Object,
            default: null
        },
        commonTravellersSet: {
            type: [Array, Object],
            default: null
        }
    },
    emits: [
        'updateOptionalArticleHeadCount',
        'optionalPrices',
        'optionalMapping'
    ],
    data() {
        return {
            selectedOption: "",
            selectedTour: null,
            selectedTourId: "aaa",
            extraDots: "",
            isQtyPopupOpen: false,
            sortingVariable: null,
            selectionOptionArray: [],
            selectedCategories: "Choose Quantities", // this will be translated according to the selected language
            selectedTourTime: "Select Tour",
            selectedCategoriesSet: [],
            componentWidth: 0,
            responsiveClass: "",
            updatedCommonTravellers: null,
            optionalComponentTitle: null,
            isAdvancedOption: false
        };
    },
    created() {
        // this.onResize();

        if (this.optionalArticle.articlesBookedPer == 'participant' && (this.optionalArticle.maximumQuantity > 0 || this.optionalArticle.minimumQuantity > 0)) {
            this.optionalComponentTitle = "Select quantities per participant";
            this.isAdvancedOption = true;
        }
        if (
            this.optionalArticle != null &&
            this.optionalArticle.tours != null &&
            this.optionalArticle.tours.length == 1
        ) {
            this.selectedTour = this.optionalArticle.tour[0];
        } else {
            this.selectedTour = null;
        }

        let newCommonTravellerSet = [];
        if (this.commonTravellersSet != null) {
            this.commonTravellersSet.forEach(commonTraveller => {
                let newCommonTraveller = {
                    key: commonTraveller.key,
                    name: commonTraveller.name,
                    value: commonTraveller.value,
                    unitPrice: commonTraveller.unitPrice
                }

                newCommonTravellerSet.push(newCommonTraveller);
            });

        }
        if (newCommonTravellerSet != null) {
            if (this.optionalArticle.otherPrices != null && this.optionalArticle.otherPrices.length > 0) {
                this.optionalArticle.otherPrices.forEach(optionalArticle => {
                    newCommonTravellerSet.forEach(commonTraveller => {
                        if (commonTraveller.key == optionalArticle.categoryCode) {
                            commonTraveller.unitPrice = optionalArticle.unitPrice;
                        }
                    });
                });
            }
            if (this.optionalArticle.articles[0].articleDescription.length >= 200) {
                this.extraDots = "..";
            }
            console.log(
                "Total Count : " + this.getTotalTravelCount(newCommonTravellerSet)
            );

            this.updatedCommonTravellers = newCommonTravellerSet;
        }
    },
    unmounted() { },
    updated() {
        // this.onResize() ;
    },
    mounted() {
        this.setOptionalArticleDetails();
        //    this.$nextTick(() => {
        //   window.addEventListener('resize', this.onResize);
        //   this.$parent.onResize();
        // })
    },
    methods: {
        quantityChange: function (selectedOption) {
            this.$emit(
                "updateOptionalArticleHeadCount",
                selectedOption,
                this.optionalArticle.articles[0].articleCode, this.optionalArticle.index
            );
        },
        quantityChangeCheckBox: function (selectedOption, commonTravellerSet) {
            console.info(commonTravellerSet);
            let selectedTraveller = null;
            commonTravellerSet.forEach(commonTraveller => {
                if (commonTraveller.value > 0) {
                    selectedTraveller = commonTraveller;
                }
            });
            console.info(selectedTraveller);

            let optionObj = {
                code: selectedTraveller.key,
                value: selectedTraveller.value,
                name: selectedTraveller.name,
                unitPrice: selectedTraveller.unitPrice,
                originalValue: null
            };

            console.info(optionObj);

            this.selectionOptionArray.push(optionObj);
            if (selectedOption == true) {

                this.$emit(
                    "updateOptionalArticleHeadCount",
                    this.selectionOptionArray,
                    this.optionalArticle.articles[0].articleCode, this.optionalArticle.index
                );
                // this.$emit(
                //   "updateOptionalArticleHeadCount",
                //   1,
                //   this.optionalArticle.articles[0].articleCode,this.optionalArticle.index
                // );
            } else {
                // this.$emit(
                //   "updateOptionalArticleHeadCount",
                //   0,
                //   this.optionalArticle.articles[0].articleCode,this.optionalArticle.index
                // );
                this.$emit(
                    "updateOptionalArticleHeadCount",
                    [],
                    this.optionalArticle.articles[0].articleCode, this.optionalArticle.index
                );
            }
        },
        tourChange: function () {
            console.log("tour");
            console.info(this.selectedTourTime);
            this.selectedTour = this.selectedTourTime;
            this.selectedTourId = this.selectedTourTime.tourId;

            this.$emit(
                "updateOptionalArticleHeadCount",
                null,
                this.optionalArticle.articles[0].articleCode,
                this.optionalArticle.index, this.selectedTourTime
            );

        },
        convertToLocal: function (date, format) {
            return moment(date).format(format);
        },
        getArrivalDate: function (date, format, duration, type) {
            return moment(date)
                .add(duration, type)
                .format(format);
        },
        getTotalTravelCount: function (commonTravellersSet) {
            let totalCount = 0;
            commonTravellersSet.forEach(commonTraveller => {
                totalCount += parseInt(commonTraveller.value);
            });
            return totalCount;
        },
        openQuantityPopup: function () {
            this.isQtyPopupOpen = true;
        },
        closeQuantityPopup: function () {
            this.isQtyPopupOpen = false;
        },
        changeItem: function (value, key, name) {
            // this.selectionOptionArray = [];
            console.info(value);
            if (this.optionalArticle.articlesBookedPer == 'booking') {
                if (value != 'default') {
                    let optionObj = {
                        code: 'perBooking',
                        value: value,
                        name: null,
                        unitPrice: 0,
                        originalValue: value,
                        isPerBooking: true
                    };

                    this.selectionOptionArray.push(optionObj);

                    this.selectedCategories = value;
                } else {
                    this.selectedCategories = "Choose Quantities";
                }
            } else {
                if (value.split("|")[0] == "default" || value == "default") {
                    if (this.selectionOptionArray.length > 0) {
                        this.selectionOptionArray.forEach(selectionOption => {
                            if (selectionOption.code == (value.split("|")[1] || key)) {
                                this.selectionOptionArray.splice(
                                    this.selectionOptionArray.indexOf(selectionOption),
                                    1
                                );
                            }
                        });
                    }

                } else {
                    let optionObj = null;

                    if (this.isAdvancedOption) {
                        optionObj = {
                            code: key,
                            value: value,
                            name: name,
                            unitPrice: 0,
                            originalValue: value,
                            isPerBooking: false,
                            isAdvancedOption: true
                        };
                    } else {

                        let code = value.split("|")[1];
                        optionObj = {
                            code: code,
                            value: value.split("|")[0],
                            name: value.split("|")[2],
                            unitPrice: value.split("|")[3],
                            originalValue: value,
                            isPerBooking: false
                        };
                    }
                    if (this.selectionOptionArray.length > 0) {
                        this.selectionOptionArray.forEach(selectionOption => {
                            if (selectionOption.code == value.split("|")[1] || selectionOption.code == key) {
                                this.selectionOptionArray.splice(
                                    this.selectionOptionArray.indexOf(selectionOption),
                                    1
                                );
                            }
                        });
                    }

                    this.selectionOptionArray.push(optionObj);
                    this.selectionOptionArray.sort();

                    console.info(this.selectionOptionArray);

                }
                this.setSelectedCategories(value, key);
            }
            // console.log(this.selectedCategories);
            this.$emit(
                "updateOptionalArticleHeadCount",
                this.selectionOptionArray,
                this.optionalArticle.articles[0].articleCode
            );

        },
        setSelectedCategories: function (value) {
            if (this.selectedCategoriesSet.length == 0) {
                this.selectedCategoriesSet.push(value);
            } else {
                // let isCodeAvailable = false;
                // let availableCode = null;
                this.selectedCategoriesSet.forEach(selectedCategory => {
                    if (selectedCategory == value) {
                        // isCodeAvailable = true;
                        // availableCode = value;
                        this.selectedCategoriesSet.splice(
                            this.selectedCategoriesSet.indexOf(selectedCategory),
                            1
                        );
                    }
                });
                this.selectedCategoriesSet.push(value);
            }

            this.selectedCategories = "";
            this.selectionOptionArray.forEach(element => {
                this.selectedCategories += element.value + " " + element.name + ", ";
            });
            this.selectedCategories = this.selectedCategories.substring(
                0,
                this.selectedCategories.length - 2
            );

            if (this.selectedCategories == "") {
                this.selectedCategories = "Choose Quantities";
            }
        },
        isInSelectedArray: function (value) {
            let isSelected = false;
            this.selectionOptionArray.forEach(selectedOption => {
                if (selectedOption.originalValue == value) {
                    isSelected = true;
                }
            });
            return isSelected;
        },
        setOptionalArticleDetails() {
            var name = this.$refs["optional_article_name_" + this.optionalArticle.articles[0].articleCode];
            this.$parent.setOptionalArticlesDetails(name, this.optionalArticle);
            var description = this.$refs["optional_article_description_" + this.optionalArticle.articles[0].articleCode];
            this.$parent.setOptionalArticlesDetails(description, this.optionalArticle);
            var image = this.$refs["optional_article_image_" + this.optionalArticle.articles[0].articleCode];
            this.$parent.setOptionalArticlesDetails(image, this.optionalArticle);
        },
        //     onResize() {
        //       if(this.$refs.optionalArticleComponentRef !=null && this.$refs.optionalArticleComponentRef!=undefined){
        //     this.componentWidth = this.$refs.optionalArticleComponentRef.clientWidth;
        //     if(this.componentWidth>1200){
        //       this.responsiveClass="break-x-large";
        //     }else if(this.componentWidth<1200 && this.componentWidth>=993){
        //       this.responsiveClass="break-x-large";
        //     }else if(this.componentWidth<993 && this.componentWidth>=769){
        // this.responsiveClass="break-large";
        //     }else if(this.componentWidth<769 && this.componentWidth>=576){
        //       this.responsiveClass="break-medium";
        //     }else if(this.componentWidth<576 && this.componentWidth>=320){
        //       this.responsiveClass="break-small";
        //     }else{
        //      this.responsiveClass="break-x-small";
        //     }
        //   }}

    }

}
</script>

<style lang="scss">
:root {
    --optional-image-background-small: "";
    --optional-image-background-medium: "";
    --optional-image-background-large: "";
    --optional-image-background-ex-large: "";
}

.article {
    padding: 0px;
    list-style-type: none;
    margin-bottom: 10px;

    .article-container {
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        width: 100%;
        padding: 6px 0 12px 0;
        position: relative;

        .image-container {
            width: 72px;
            height: 72px;
            float: left;
            position: relative;

            .image-wrapper {
                position: relative;
                width: 100%;
                height: 100%;
                padding: 10px;
                box-sizing: border-box;

                .image {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                    background-color: #dcdcdc;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='22.775mm' height='19.059mm' viewBox='0 0 22.775 19.059' version='1.1' id='svg917' inkscape:version='0.92.3 (2405546, 2018-03-11)' sodipodi:docname='default image.svg'%3E%3Cdefs id='defs911' /%3E%3Csodipodi:namedview id='base' pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1.0' inkscape:pageopacity='0.0' inkscape:pageshadow='2' inkscape:zoom='0.35' inkscape:cx='-77.142857' inkscape:cy='560' inkscape:document-units='mm' inkscape:current-layer='layer1' showgrid='false' inkscape:window-width='1920' inkscape:window-height='1001' inkscape:window-x='2391' inkscape:window-y='-9' inkscape:window-maximized='1' /%3E%3Cmetadata id='metadata914'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3Cdc:title%3E%3C/dc:title%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cg inkscape:label='Layer 1' inkscape:groupmode='layer' id='layer1' transform='translate(0,-277.941)'%3E%3Cg id='g862' transform='matrix(0.40061584,0,0,0.40061584,-91.776786,298.0575)' style='fill:%23ffffff'%3E%3Cpath id='rect839' transform='scale(0.26458333)' d='M 911.42773,-137.83789 V -9.9804688 H 1080.7148 V -137.83789 Z m 11.25,10.71484 H 1069.4648 V -21.408203 H 922.67773 Z' style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:98.92913055;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' inkscape:connector-curvature='0' /%3E%3Cpath inkscape:connector-curvature='0' id='path845' d='m 249.22883,-9.5581485 h 29.53328 l -3.67495,-13.0962065 -3.54132,1.002261 -2.27179,-5.011304 -8.41899,12.49485 -4.6104,-3.140417 z' style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' /%3E%3Ccircle r='3.6749561' cy='-24.725693' cx='252.83698' id='path847' style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:26.17499924;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' /%3E%3Cpath id='path849' transform='scale(0.26458333)' d='m 1024.0156,-189.7832 -158.16599,60.3457 45.57812,119.4589844 29.95704,-11.4296874 h -18.70704 v -5.09375 l -4.8125,1.835937 -37.68554,-98.771484 137.14451,-52.32422 18.5567,48.63867 h 12.0429 z m 45.4492,119.119138 v 0.386718 l 0.129,-0.04883 z' style='fill:%23ffffff;fill-opacity:1;stroke:none;stroke-width:98.92913055;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1' inkscape:connector-curvature='0' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
                    background-size: cover;

                    // Extra small devices (portrait phones, less than 576px)
                    @media (max-width: 575.98px) {
                        background-image: var(--optional-image-background-xsmall);
                    }

                    // Small devices (landscape phones, 576px and up)
                    @media (min-width: 576px) {
                        background-image: var(--optional-image-background-medium);
                    }

                    // Medium devices (tablets, 768px and up)
                    @media (min-width: 768px) {
                        background-image: var(--optional-image-background-medium);
                    }

                    // Large devices (desktops, 992px and up)
                    @media (min-width: 992px) {
                        background-image: var(--optional-image-background-large);
                    }

                    // Extra large devices (large desktops, 1200px and up)
                    @media (min-width: 1200px) {
                        background-image: var(--optional-image-background-ex-large);
                    }
                }
            }
        }

        .description-container {
            width: calc(100% - 100px);
            float: left;

            .description-wrapper {
                .details-container {
                    width: calc(100% - 146px);
                    float: left;
                    padding: 10px 14px 0 0;
                    box-sizing: border-box;

                    .details-title {
                        font-size: 16px;
                    }

                    .details-wrapper {
                        ::v-deep p {
                            margin: 0px;
                            font-size: 13px;
                            margin-top: 8px;
                            font-size: 14px;
                            color: #818181;
                        }

                        margin-top: -4px;
                    }
                }

                .counter-container {
                    width: 146px;
                    float: left;

                    .counter-wrapper {
                        .counter-label {
                            margin: 16px 0 8px 0;
                            font-size: 14px;
                        }

                        .counter {
                            margin: 22px 0 8px 0;

                            select {
                                padding: 8px 10px;
                                border-radius: 4px;
                                border: 1px solid #cacaca;
                                font-family: inherit;
                                font-size: 13px;
                                color: #2c3e50;
                                cursor: pointer;
                                outline: none;
                                width: 145px;
                            }

                            .choose-quantity {
                                background-color: #ffffff;
                                display: inline-block;
                                padding: 8px 10px;
                                font-size: 12px;
                                /* font-weight: 600; */
                                border-radius: 4px;
                                border: 1px solid #cbcbcb;
                                min-width: 100px;
                                cursor: pointer;
                            }
                        }

                        .optional-art-tours {
                            select {
                                padding: 6px 5px;
                                border-radius: 4px;
                                cursor: pointer;
                                outline: none;
                                width: 100%;
                                margin-top: 23px;
                            }
                        }
                    }
                }
            }
        }

        .qty-popup-container {
            position: absolute;
            width: calc(100% + 1px);
            height: calc(100% + 1px);
            top: 0;
            left: -1px;
            border-radius: 8px;
            z-index: 10;

            .overlay {
                position: absolute;
                width: calc(100% + 2px);
                height: 100%;
                background-color: rgba(0, 0, 0, .33);
                border-radius: 4px;

                .popup {
                    width: fit-content;
                    height: fit-content;
                    min-height: 10px;
                    background-color: #ffffff;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    margin: auto;
                    border-radius: 4px;

                    .popup-container {
                        // Price group popup
                        position: relative;
                        width: 100%;
                        height: 100%;
                        padding: 4px;
                        box-sizing: border-box;

                        .close {
                            position: absolute;
                            width: 22px;
                            height: 22px;
                            background-color: #ffffff;
                            box-shadow: 0px 0px 3px #000000;
                            z-index: 10;
                            right: -7px;
                            top: -6px;
                            border-radius: 26px;
                            cursor: pointer;

                            &::before {
                                content: " ";
                                width: 12px;
                                height: 2px;
                                position: absolute;
                                left: 0;
                                right: 0;
                                top: 0;
                                bottom: 0;
                                margin: auto;
                                background-color: #333;
                                border-radius: 14px;
                                -webkit-transform: rotate(-45deg) !important;
                                transform: rotate(-45deg) !important;
                            }

                            &::after {
                                content: " ";
                                width: 12px;
                                height: 2px;
                                position: absolute;
                                left: 0;
                                right: 0;
                                top: 0;
                                bottom: 0;
                                margin: auto;
                                position: absolute;
                                background-color: #333;
                                border-radius: 14px;
                                -webkit-transform: rotate(45deg) !important;
                                transform: rotate(45deg) !important;
                            }
                        }

                        .drop-container {
                            .optionItem {
                                width: 96px;
                                float: left;
                                padding: 4px 4px 2px 4px;

                                .label {
                                    font-size: 12px;
                                    font-weight: 600;
                                }
                            }

                            select {
                                padding: 10px;
                                border: 1px solid #d1d0d0;
                                border-radius: 3px;
                                width: fit-content;
                                width: 100%;
                                float: left;
                                margin-right: 4px;
                                margin: 4px 0px 4px 0;
                                cursor: pointer;
                                outline: none;

                                option {
                                    padding: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.optional-article-set.break-small,
.optional-article-set.break-x-small {

    .details-container {
        width: 100% !important;
    }

}

.optional-article-set.break-x-small {

    .details-container {
        padding: 14px !important;
        text-align: center;
    }

    .image-container {
        float: none !important;
        margin: auto !important;
    }

    .description-container {
        width: 100% !important;
    }

    .counter-container {
        margin: auto;
        width: fit-content !important;
        width: auto !important;
        float: initial !important;
        display: table;

        .check {
            margin-top: 0px;
        }
    }
}

// Checkbox
.check {
    margin-top: 32px;

    /* Customize the label (the container) */
    .check-container {
        padding: 0px;
        padding-top: 1px;
        position: relative;
        padding-left: 30px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .check-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }

    .fade-enter,
    .fade-leave-to

    /* .fade-leave-active below version 2.1.8 */
        {
        opacity: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: -3px;
        left: 0;
        height: 22px;
        width: 22px;
        background-color: #fff;
        border: 1px solid #bcb2b2;
    }

    /* On mouse-over, add a grey background color */
    .check-container:hover input~.checkmark {
        // background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .check-container input:checked~.checkmark {
        // background-color: #2196F3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    /* Show the checkmark when checked */
    .check-container input:checked~.checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .check-container .checkmark:after {
        left: 7px;
        top: 3px;
        width: 5px;
        height: 10px;
        border: solid #333333;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
}
</style>
